import React from 'react';
import styled from 'styled-components';
import { white } from '@spotify-internal/encore-foundation';
import { Type } from '@spotify-internal/encore-web';
import { Box } from '../../ui';
import { SearchBar } from '../../Search';
import { getBurst } from '../../utils';
import { useT } from '@mrkt/features/i18n';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var HELP_HOME_TRACK_CAT = 'helpHome';
var HeaderWrapper = styled(Box).withConfig({
  displayName: "HelpHeader__HeaderWrapper",
  componentId: "sc-11nlev-0"
})(["background-color:", ";color:", ";justify-content:center;height:300px;", ""], function (props) {
  return props.backgroundColor;
}, white, function (_ref) {
  var theme = _ref.theme;
  return getBurst(theme.help.banner.text);
});
var Header = styled.div.withConfig({
  displayName: "HelpHeader__Header",
  componentId: "sc-11nlev-1"
})(["max-width:984px;margin-left:auto;margin-right:auto;"]);
var Headline = styled(Type.h1).attrs({
  variant: Type.heading1,
  weight: Type.bold
}).withConfig({
  displayName: "HelpHeader__Headline",
  componentId: "sc-11nlev-2"
})(["padding-top:100px;"]);
export var HelpHeader = function HelpHeader(_ref2) {
  var _ref2$headline = _ref2.headline,
      headline = _ref2$headline === void 0 ? '' : _ref2$headline,
      backgroundColor = _ref2.backgroundColor;
  var t = useT();
  return /*#__PURE__*/_jsx(HeaderWrapper, {
    backgroundColor: backgroundColor,
    children: /*#__PURE__*/_jsxs(Header, {
      children: [/*#__PURE__*/_jsx(Headline, {
        children: headline
      }), /*#__PURE__*/_jsx(SearchBar, {
        placeholder: t('FRODOR_dc8696', 'Search articles and resources', ''),
        contentTypes: ['faq'],
        trackCategory: "helpHeader",
        suggestCount: 5,
        getSuggestUrl: function getSuggestUrl(sug) {
          return "".concat(sug.url, "?ref=sug_").concat(HELP_HOME_TRACK_CAT);
        }
      })]
    })
  });
};